import React from "react";

import { CheckCircleOutline, WarningAmberOutlined } from "@mui/icons-material";
import { Alert, Skeleton, Typography } from "@mui/material";
import { InvoiceApprovalStatus } from "libLegacy/api/models";

const invoiceTexts = {
  CONSISTENT: "Analisamos a fatura deste mês em detalhes e está tudo certo!",
  INCONSISTENT:
    "Encontramos divergência de dados na sua fatura. Veja a nossa análise.",
};

const invoiceAlertVariant = (status: InvoiceApprovalStatus) => {
  switch (status) {
    case "CONSISTENT":
      return "success";
    default:
      return "warning";
  }
};

const InvoiceAlertIcon = ({ status }) => {
  switch (status) {
    case "INCONSISTENT":
      return <WarningAmberOutlined />;
    default:
      return <CheckCircleOutline />;
  }
};

export const InvoiceApprovalAlert: React.FC<InvoiceApprovalAlertProps> = ({
  status,
  isLoading,
}) => {
  return (
    <>
      {!status || isLoading ? (
        <Skeleton variant="rectangular" height={70} />
      ) : (
        <Alert
          icon={<InvoiceAlertIcon status={status} />}
          color={invoiceAlertVariant(status)}
          variant="outlined"
          sx={{ alignItems: "center" }}
        >
          <Typography variant="body1" color="text.primary" fontWeight={500}>
            {invoiceTexts[status]}
          </Typography>
        </Alert>
      )}
    </>
  );
};

export type InvoiceApprovalAlertProps = {
  status: InvoiceApprovalStatus | undefined;
  isLoading: boolean | undefined;
};
